import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const FAQS = [
  {
    q: "Qual é a diferença entre o Pacote Essencial e o Pacote Completo?",
    a: "Ambos os pacotes dão acesso aos mesmos conteúdos: +50 aulas gravadas dos 7 módulos, +1 ano de plataforma, atualizações mensais e orientação profissional. A diferença está no Pacote Completo (€147), que inclui a avaliação teórica online e a certificação de 15h via SIGO / Passaporte Qualifica — ou seja, o cartão oficial de Manobrador CFOMP/SIGO reconhecido em PT e na UE. O Pacote Essencial (€37 + IVA) é para quem quer apenas o conhecimento, sem o certificado oficial.",
  },
  {
    q: "O que está incluído no curso?",
    a: "Acesso a +50 aulas gravadas dos 7 módulos, atualizações mensais, acesso por 1 ano à plataforma e orientação profissional. Podes fazer o curso pelo celular ou computador, sem horários fixos. No Pacote Completo também tens avaliação teórica online + certificação SIGO / Passaporte Qualifica com o cartão oficial CFOMP/SIGO.",
  },
  {
    q: "Como funciona a certificação? (Pacote Completo)",
    a: "Após concluíres os módulos e a avaliação teórica do Pacote Completo, recebes o cartão Manobrador de Grua Torre com certificação CFOMP/SIGO, registado no Passaporte Qualifica. É reconhecido em Portugal e na União Europeia. O Pacote Essencial NÃO inclui certificação.",
  },
  {
    q: "Este curso substitui a formação prática?",
    a: "A formação teórica do Pacote Completo é suficiente para obteres a certificação SIGO. A aula prática presencial com o Kawan é um serviço opcional, separado do curso online e pago à parte — alunos de qualquer um dos pacotes têm desconto exclusivo sobre o valor público, sujeito à disponibilidade de agenda do Kawan.",
  },
  {
    q: "Consigo trabalho com este curso?",
    a: "Para concorreres a vagas em Portugal precisas do cartão SIGO — incluído no Pacote Completo. O mercado está em falta de manobradores certificados e +1.900 alunos já fizeram o percurso. Se escolheres o Pacote Essencial terás o conhecimento mas não o cartão oficial.",
  },
  {
    q: "E se eu não gostar? Tenho garantia?",
    a: "Sim — garantia blindada de 14 dias, contados da data da compra. Se por qualquer motivo não ficares 100% satisfeito, basta enviar um email para info@manobradordegruakawan.com e devolvemos o valor integral, sem perguntas, sem burocracia. O reembolso é processado pela Hotmart e o valor é devolvido no método de pagamento original em até 30 dias.",
  },
  {
    q: "Posso ver no telemóvel ou no computador?",
    a: "Sim. Todas as aulas funcionam no celular e no computador, sem horários fixos. Estudas onde e quando quiseres, à tua velocidade, durante 1 ano.",
  },
];

export default function FAQ() {
  return (
    <section
      className="py-24 sm:py-32 bg-zinc-950 border-b border-white/10"
      data-testid="faq-section"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12">
          <div className="text-xs uppercase tracking-[0.3em] text-yellow-400 mb-3">Perguntas</div>
          <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl leading-[0.9]">
            TIRA <br />
            <span className="text-yellow-400">AS DÚVIDAS.</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full border-t border-white/10">
          {FAQS.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-b border-white/10"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="text-left text-lg sm:text-xl text-white hover:text-yellow-400 hover:no-underline py-6 font-display uppercase tracking-wide">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-zinc-400 text-base leading-relaxed pb-6">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
